import Container from '@mui/material/Container';
import { PATH_DASHBOARD } from '../../../routes/paths';
import useSettings from '../../../hooks/useSettings';
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import type { RouteComponentProps } from '@reach/router';
import { PolicyStreamAdvisorsMP } from './PolicyStreamAdvisorsMP';
import { DashboardPageFrame } from '../DashboardPageFrame';

interface CompanyAdvisorsPageProps extends RouteComponentProps {}

export function CompanyAdvisorsPage(_props: CompanyAdvisorsPageProps) {
  const { themeStretch } = useSettings();

  return (
    <Page title='Settings: Company Advisors | Manager'>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading='Settings'
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Settings', href: PATH_DASHBOARD.settings.root },
            { name: 'Company advisors settings' },
          ]}
        />
        <DashboardPageFrame
          title='Company Advisors Settings'
          description='Manage advisor profiles and insurer relationships for this company.'
        >
          <PolicyStreamAdvisorsMP />
        </DashboardPageFrame>
      </Container>
    </Page>
  );
}
